import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "notice" ]

  close() {
    console.log("CLOSE");
    this.noticeTarget.style.display = 'none';
  }
}
